import { Button } from "reactstrap";

interface Props {
  handleNext: (event: any) => void;
}

export const StepOne: React.FC<Props> = ({ handleNext }) => {
  // const [isChecked, setIsChecked] = useState(false);

  // const handleCheckboxChange = (e: { target: { checked: boolean | ((prevState: boolean) => boolean); }; }) => {
  //   setIsChecked(e.target.checked);
  // };

	return (
		<>
      {/* <Alert color="warning">
        【ご案内】<br />
        2026年7月1日より会費が改定となっております。
        本ページは、会員資格の確認およびID・パスワード発行手続き専用ページです。
        お手数ですが、まずは本ページにて該当する会員資格をご確認のうえ、ID・パスワード発行のお手続きをお願いいたします。<strong>会費につきましては、ID・パスワードのご連絡時に事務局より別途メールにてご案内申し上げます。</strong>
        ご不便をおかけし誠に申し訳ございませんが、ご理解、ご協力の程、お願い申し上げます。<br /><br />
        
        【Notice】<br />
        Please be advised that membership fees have been revised effective 1 July 2026.
        This page is intended solely for membership category confirmation and ID/password issuance.
        We kindly ask that you use this page to confirm the applicable membership category and complete the ID/password issuance process. <strong>The exact membership fee applicable to your membership category will be communicated separately by the Secretariat via email when your ID and password are issued.</strong>
        We sincerely apologize for any inconvenience this may cause and appreciate your understanding and cooperation.
      </Alert> */}
      <h2 className='pt-5 pb-3 font-weight-bold'><strong>新規会員登録 / New Membership Registration</strong></h2>
      <div className="divider"></div>
      <h3 style={{ fontSize: '16px', color: '#808080' }}>途中で保存することができないので事前にご準備いただいてから登録をスタートしてください。</h3>
      <h4 style={{ fontSize: '16px', color: '#808080' }}>Please prepare the necessary details in advance before starting the registration.</h4>
      <ul className="mt-5">
        <li className="mt-3" style={{ fontSize: '18px' }}>次のページからの会員カテゴリーチェック表で入会資格を満たしていることを確認できます。</li>
        <li className="mt-3" style={{ fontSize: '18px' }}>You can check if you're eligible for membership using the category checklist on the next page.</li>
      </ul>
      <div className='justify-content-end d-flex pt-5'>
				<Button 
					color="info" 
					outline
          onClick={handleNext}
					>次へ / Next
				</Button>
			</div>
      {/* <div className="mt-5">
        <FormGroup check>
          <Input 
            type="checkbox"
            onChange={handleCheckboxChange}
            checked={isChecked} 
          />
          {' '}
          <Label check>
            確認しました / Confirmed
          </Label>
        </FormGroup>
      </div> */}
      {/* <div className='justify-content-end d-flex pt-5'>
				<Button 
					color="info" 
					outline
          disabled={!isChecked}
          onClick={handleNext}
					>次へ / Next
				</Button>
			</div> */}
		</>
	)
}

export default StepOne;